import { renderSlot as _renderSlot, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x.svg'


const _hoisted_1 = {
  key: 0,
  class: "font-montserrat"
}
const _hoisted_2 = { class: "justify-center items-center py-6 flex overflow-hidden fixed inset-0 z-40 outline-none focus:outline-none" }
const _hoisted_3 = { class: 
          `w-2/5 relative flex flex-col justify-between bg-white rounded-xl`
         }
const _hoisted_4 = { class: `px-4 py-2 border-gray-lp-400 border-b` }
const _hoisted_5 = { class: "inline-flex justify-between w-full" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-base mr-4 text-gray-lp-300" }, " Semua produk pesanan ", -1)
const _hoisted_7 = {
  class: "content overflow-auto px-4",
  style: {"height":"25vh"}
}
const _hoisted_8 = { class: "flex gap-4 py-2 text-black-lp-100" }
const _hoisted_9 = { class: "items-center flex text-sm" }
const _hoisted_10 = { class: "overflow-hidden" }
const _hoisted_11 = { class: "text-[16px] font-bold overflow-hidden overflow-ellipsis whitespace-nowrap" }
const _hoisted_12 = { class: "text-sm" }
const _hoisted_13 = { class: "text-sm border-t px-4 py-2 flex justify-between text-gray-lp-300" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, " Total kuantitas ", -1)
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "opacity-75 fixed inset-0 z-30 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showPopupDetailProduct)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default", {}, () => [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode("img", {
                    src: _imports_0,
                    class: "w-4 cursor-pointer",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClosePopup && _ctx.onClosePopup(...args))),
                    alt: "x"
                  })
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (detail, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, [
                    _createVNode("div", _hoisted_8, [
                      _createVNode("div", _hoisted_9, _toDisplayString(index + 1), 1),
                      _createVNode("img", {
                        src: detail.kodProductThumbnail,
                        alt: "Gambar",
                        class: "w-10 rounded"
                      }, null, 8, ["src"]),
                      _createVNode("div", _hoisted_10, [
                        _createVNode("p", _hoisted_11, _toDisplayString(detail.kodProductName), 1),
                        _createVNode("p", _hoisted_12, _toDisplayString(detail.kodQuantity) + " X " + _toDisplayString(_ctx.formatPrice(detail.kodPrice)), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _createVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode("div", _hoisted_15, _toDisplayString(_ctx.sumQuantity), 1)
              ])
            ])
          ])
        ]),
        _hoisted_16
      ]))
    : _createCommentVNode("", true)
}